import { motion } from "framer-motion";

export function CommissionTracker({ stores, totalCommission }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="bg-igc-surface border border-igc-gold/15 p-6 mb-8" data-testid="commission-tracker">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-4" title="IGC's own cut of client revenue, taken as a 10% royalty once each client has recovered their upfront investment.">IGC Commission Tracker — 10% Royalty Post-Recovery</p>
      <p className="font-serif text-3xl text-igc-success mb-4" data-testid="total-igc-commission" title="The total royalty commission IGC has earned across all client stores combined.">${totalCommission.toLocaleString()}</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {stores.map((s) => (
          <div key={s.client_id} className="flex justify-between text-sm border-b border-igc-gold/10 pb-2" data-testid={`commission-row-${s.client_id}`}>
            <span className="text-igc-muted">{s.display_name}</span>
            <span className={s.igc_commission_earned > 0 ? "text-igc-success" : "text-igc-muted"}>${s.igc_commission_earned.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
